import { Divider, Paper, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import ResultsTable from './ResultsTable/ResultsTable';

type Props = {
  rid: string;
};

const ResultsPipelineOverview = ({ rid }: Props): JSX.Element => {
  return (
    <Paper elevation={2} sx={{ px: 2, py: 2 }}>
      <Stack direction={'column'} spacing={1}>
        <Typography variant={'h4'}>
          <Trans>Service Results</Trans>
        </Typography>
        <Divider />
        <ResultsTable rid={rid}/>
      </Stack>
    </Paper>
  );
};

export default ResultsPipelineOverview;
